import { render, staticRenderFns } from "./ConstructorOnceAnswer.vue?vue&type=template&id=114cbf02&scoped=true&"
import script from "./ConstructorOnceAnswer.vue?vue&type=script&lang=js&"
export * from "./ConstructorOnceAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114cbf02",
  null
  
)

export default component.exports